import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet"

const html = `
<style>
#form-component + div {
    display:none;
}
</style>

<h2>About this map</h2>
<p>If you are thinking to build or develop something, you can use this map to identify possible environmental factors that might affect your project. The map will display any relevant local or national policies, as well as other useful information such as if the area is a flood risk or conservation area. There is no charge to use this map.</p>
<h2>Using the map</h2>
<p>Pinpoint the location of where you are interested in developing on the map below or you can search via address. Information about that area will then be displayed below the map. The map can take up to a minute to completely load.</p>
<div id="sgc_form--pe--step-map" class="form-step map-singular" data-mapstep="true" data-mapsingular="true" style="position:relative">
    <div class="question-section">
      
        <!-- hide the search until the map has loaded -->
        <div id="mapholder">
            <div id="mapLoadingZone">
                <span class="loading-icon"></span>
                <h3 class="d-inline">Loading map, please wait...</h3>
            </div>
            
            <div id="mySearch" class="clearfix hide">
                <h6>Search via address (postcode, streetname or partial address name)</h6>
                <p>You can either search, or drop a pin on the map</p>
                <div id="searchPlaceholderTag"></div>
                <button class="button button--primary" id="quickSearch-Search" style="height:45px;">Find location</button>
            </div>
            <div id="MapPlaceholder">
        <a href="javascript:void(0);" onclick="mapPinLoc.setMapToUserLocation()"
            class="useMyLocation button button--secondary--locate button__xsmall" id="locationFinderBtn">
           Use my location
        </a>
            </div>
        </div>
        <!-- map results here -->
        <div id="FeatureInfoResults" class="mtop-20">
        <div id="error-map">    
        <div id="error-message"></div>
        </div>
        <div id="loading-map-data" style="display:none"><p class="heading3"><span class="loading-icon"></span>Retrieving information about the selected location</p></div>
        <div id="all-information">
            <div id="additional-information" class="mtop-20 hide">
                <div><h3>The following were identified for the location you have selected</h3></div> 
            <!-- results are populated here -->
            </div>
            <div id="additional-information-noimpact" class="hide"> 
                <h3>The following were checked for but not identified for this location</h3>
                <!-- results are populated here -->
                <ul></ul>
            </div>
        </div>
        <div id="nextsteps" class="hide">
        <!--//@todo links-->
        <h3 class="heading2">Next steps</h3>
            <p>Further information on <a href="https://beta.southglos.gov.uk/planning-permission-and-consent/" target="_blank">planning permission and consent is available on our website</a>. The <a href="https://www.planningportal.co.uk/info/200125/do_you_need_permission" target="_blank">planning portal</a> has a list of common projects and guides to help you decide if you need permission and what you need to consider.  You should also check if any other permissions or consent is needed before you start work. If you know that planning permission is needed for your project, you can apply for an <a href="https://beta.southglos.gov.uk/pre-application-planning-advice/" target="_blank">informal pre-application assessment</a>* before you <a href="https://beta.southglos.gov.uk/submit-a-planning-application/" target="_blank">submit your planning application</a>.  *There is a fee involved for this service.</p>
            <p>If you are submitting a planning application, check <a href="https://beta.southglos.gov.uk/what-you-need-to-submit-with-your-planning-application/" target="_blank">what information you need to submit with your application</a>.</p>
        </div>
        <div class="">
            <h3 class="heading2">Disclaimer</h3>
            <p>This map is for informational purposes only and is to be used at your own risk. Whilst we do our best to ensure the information is up to-date and correct, we cannot be held responsible for the accuracy of the information and do not give any warranty or representation, express or implied, in respect of its completeness or suitability for any particular purpose. You should seek further professional advice before making any decisions based on the results of using this map.</p>
        </div>
        <h3 class="heading2">Support</h3> 
        <p>If you are unable to use this map, you can call us on <a href="tel:01454 868004">01454 868004</a>.</p>
    </div>

        <input type="hidden" id="MapInteractionType" value="131370000">
        <!--<input type="hidden" id="MapUri" value="https://maps.southglos.gov.uk/map/GetMap.axd">-->
        <input type="hidden" id="MapUri" value="https://maps.southglos.gov.uk/MAP/GetMap.axd">


        <!--<input type="hidden" id="MapUri" value="/">-->
        <!-- dynamically populated from the triage-->
        <input type="hidden" id="MapName" value="PLANNING_DEV_MAP_11" />
        <input type="hidden" id="MapLayerSelectionName-Global" value="UnitaryBoundary_SG,Greenbelt_SG,ResponsibilityBoundary_All"/>
        <input type="hidden" id="MapLayerSelectionName" value=",Floodzones_SG, SiteOfSpecialScientificInterest_SG,ConservationAreas_SG, FreeholdLand_SG"/>
        <!--results count-->
        <input type="hidden" id="MapResultsCount" value="0"/>
        <!--llb-lb count-->
        <input type="hidden" id="llb-flag" value=""/>
        <input type="hidden" id="lb-flag" value=""/>
        <div class="hide">
                               
                                <td colspan="1" rowspan="1" class="clearfix&#32;cell&#32;text&#32;form-control-cell">
                                    <div class="info"><label for="lace_poilatitude" id="lace_poilatitude_label">Latitude
                                            (POI)</label>
                                        <div class="validators"><span id="MaximumLengthValidatorlace_poilatitude"
                                                style="visibility:hidden;">*</span></div>
                                    </div>
                                    <div class="control"><input
                                            name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_poilatitude"
                                            type="text" maxlength="100" id="lace_poilatitude"
                                            class="text&#32;form-control&#32;" onchange="setIsDirty(this.id);"
                                            value="51.53639209996545" /></div>
                                </td>
                                <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1"
                                        class="clearfix&#32;cell&#32;text&#32;form-control-cell">
                                        <div class="info"><label for="lace_easting"
                                                id="lace_easting_label">Easting</label>
                                            <div class="validators"><span id="MaximumLengthValidatorlace_easting"
                                                    style="visibility:hidden;">*</span></div>
                                        </div>
                                        <div class="control"><input
                                                name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_easting"
                                                type="text" maxlength="100" id="lace_easting"
                                                class="text&#32;form-control&#32;" onchange="setIsDirty(this.id);"
                                                value="371126" /></div>
                                    </td>
                                    <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1"
                                        class="clearfix&#32;cell&#32;text&#32;form-control-cell">
                                        <div class="info"><label for="lace_poilongitude"
                                                id="lace_poilongitude_label">Longitude (POI)</label>
                                            <div class="validators"><span id="MaximumLengthValidatorlace_poilongitude"
                                                    style="visibility:hidden;">*</span></div>
                                        </div>
                                        <div class="control"><input
                                                name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_poilongitude"
                                                type="text" maxlength="100" id="lace_poilongitude"
                                                class="text&#32;form-control&#32;" onchange="setIsDirty(this.id);"
                                                value="-2.417689148459224" /></div>
                                    </td>
                                    <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1"
                                        class="clearfix&#32;cell&#32;text&#32;form-control-cell">
                                        <div class="info"><label for="lace_northing"
                                                id="lace_northing_label">Northing</label>
                                            <div class="validators"><span id="MaximumLengthValidatorlace_northing"
                                                    style="visibility:hidden;">*</span></div>
                                        </div>
                                        <div class="control"><input
                                                name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_northing"
                                                type="text" maxlength="100" id="lace_northing"
                                                class="text&#32;form-control&#32;" onchange="setIsDirty(this.id);"
                                                value="182026" /></div>
                                    </td>
                                    <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1" class="clearfix&#32;cell&#32;boolean-radio-cell">
                                        <div class="info"><label id="lace_poiwithinboundary_label">Is POI Within
                                                Boundary</label>
                                            <div class="validators"></div>
                                        </div>
                                        <div class="control"><span id="lace_poiwithinboundary"
                                                class="boolean-radio&#32;" onchange="setIsDirty(this.id);"><input
                                                    id="lace_poiwithinboundary_0" type="radio"
                                                    name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_poiwithinboundary"
                                                    value="0" checked="checked" /><label
                                                    for="lace_poiwithinboundary_0"><span class='sr-only'>Is POI Within
                                                        Boundary </span>No</label><input id="lace_poiwithinboundary_1"
                                                    type="radio"
                                                    name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_poiwithinboundary"
                                                    value="1" /><label for="lace_poiwithinboundary_1"><span
                                                        class='sr-only'>Is POI Within Boundary </span>Yes</label></span>
                                        </div>
                                    </td>
                                    <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1"
                                        class="clearfix&#32;cell&#32;integer&#32;form-control-cell">
                                        <div class="info"><label for="lace_poizoomlevel"
                                                id="lace_poizoomlevel_label">POI Zoom Level</label>
                                            <div class="validators"><span id="IntegerValidatorlace_poizoomlevel"
                                                    style="visibility:hidden;">*</span><span
                                                    id="RangeValidatorlace_poizoomlevel"
                                                    style="visibility:hidden;">*</span></div>
                                        </div>
                                        <div class="control"><input
                                                name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_poizoomlevel"
                                                type="text" id="lace_poizoomlevel"
                                                class="text&#32;integer&#32;form-control&#32;" value="9"
                                                onchange="setIsDirty(this.id);" /></div>
                                    </td>
                                    <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1"
                                        class="clearfix&#32;cell&#32;text&#32;form-control-cell">
                                        <div class="info"><label for="lace_assetid"
                                                id="lace_assetid_label">AssetId</label>
                                            <div class="validators"><span id="MaximumLengthValidatorlace_assetid"
                                                    style="visibility:hidden;">*</span></div>
                                        </div>
                                        <div class="control"><input
                                                name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_assetid"
                                                type="text" maxlength="20" id="lace_assetid"
                                                class="text&#32;form-control&#32;" onchange="setIsDirty(this.id);" />
                                        </div>
                                    </td>
                                    <td class="cell&#32;zero-cell"></td>
                                </tr>
                                <tr>
                                    <td colspan="1" rowspan="1"
                                        class="clearfix&#32;cell&#32;text&#32;form-control-cell">
                                        <div class="info"><label for="lace_assettype" id="lace_assettype_label">Asset
                                                Type</label>
                                            <div class="validators"><span id="MaximumLengthValidatorlace_assettype"
                                                    style="visibility:hidden;">*</span></div>
                                        </div>
                                        <div class="control"><input
                                                name="ctl00$ContentContainer$WebFormControl_b9ebda083c3be911a8c200224801a03a$EntityFormView$lace_assettype"
                                                type="text" maxlength="20" id="lace_assettype"
                                                class="text&#32;form-control&#32;" onchange="setIsDirty(this.id);" />
                                        </div>
                                    </td>
                                </tr>
                            </div>
    </div>
    <style>
        .olMap img {max-width:none !important;}
    </style>
</div>

`

function LoadPlanningInfoMap() {
    useEffect(() => {
        const script = document.createElement('script');
      
        script.src = "https://beta.southglos.gov.uk/wp-includes/planninginfomap.js";
        script.async = true;
      
        document.body.appendChild(script);
      
        return () => {
          document.body.removeChild(script);
        }
      }, []);
}




const PlanningInformationMap = () => (
   
    
   <>
   {LoadPlanningInfoMap()}
   <Helmet>
        <script type="text/javascript" src="https://maps.southglos.gov.uk/map/GetSearch.axd?embeddedControlId=mySearch&delay=500000000&controlTagId=searchPlaceholderTag&searchSelectHandler=resultSelectedHandler&initialamountofresultstofetch=999&extraresultstofetch=999"></script>
        
    </Helmet>
    <div dangerouslySetInnerHTML={{ __html: html }} />  

     

</>

)
export default PlanningInformationMap